<template>
  <Modal
    width="920"
    title="计划管家选择"
    v-model="state"
    class-name="c-manage vertical-center-modal"
    @on-visible-change="bindGetData"
    :closable="false"
    :mask-closable="false"
  >
    <!-- <Spin size="large" fix v-if="show"></Spin> -->
    <Row class="filter-box" :gutter="12">
      <Col span="6">
        <Input v-model.trim="keyword" placeholder="请输入关键词" search enter-button @on-search="search" @on-enter="search"></Input>
      </Col>
    </Row>
    <Row>
      <Col span="24">
        <Table height="360" :loading="show" :columns="columns" :data="manageList" highlight-row @on-current-change="bindCurrentRow"></Table>
        <Page show-total :current.sync="pageIndex" :total="total" :page-size="pageSize" @on-change="changePageIndex" class="page-index" />
      </Col>
    </Row>
    <Row slot="footer" :gutter="12">
      <Button type="default" @click="$emit('on-cancel')">取消</Button>
      <Button type="primary" @click="save">确定</Button>
    </Row>
  </Modal>
</template>
<script>
import { isArray } from '@/common/js/utils'
import { queryButlerList } from '@/api/toutiao.model'
import columns from './columns.json'
export default {
  name: 'manager',
  props: {
    value: {
      type: Boolean
    },
    selection: {
      type: Array
    }
  },
  computed: {
    state: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    }
  },
  methods: {
    bindGetData(val) {
      // 显示时请求数据
      this.manageList = []
      this.keyword = ''
      this.pageIndex = 1
      val && this.getData()
    },
    changePageIndex(index) {
      this.pageIndex = index
      this.getData()
    },
    getData() {
      this.show = true
      queryButlerList({
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
        keyword: this.keyword
      }).then((data) => {
        this.show = false
        if (data && isArray(data.list) && data.page_info) {
          this.total = data.page_info.total_number
          this.manageList = data.list.map((ret) => {
            const ids = this.selection.map((r) => r.id)
            if (ids.includes(ret.id)) ret._highlight = true
            return ret
          })
        }
      })
    },
    // 选中当前项
    bindCurrentRow(currentRow) {
      this.currentRow = currentRow
    },
    search() {
      this.pageIndex = 1
      this.getData()
    },
    save() {
      if (!this.currentRow) {
        this.$Message.warning('您未选择一个计划管家')
        return false
      }
      this.$emit('on-select', this.currentRow)
    }
  },
  data() {
    return {
      show: null,
      keyword: '',
      pageIndex: 1,
      pageSize: 10,
      total: 0,
      columns: columns,
      manageList: []
    }
  }
}
</script>
<style lang="scss" scoped>
.c-manage {
  position: relative;
}

.filter-box {
  margin-bottom: 12px;
}

.page-index {
  margin-top: 12px;
  text-align: right;
}
</style>
